import React from 'react';
import { ErrorHandler, Gap, LoadingState, Tag, Text } from '@common/components';
import { useQuery } from '@common/hooks';
import { LOAD_BALANCING_WORKER_SKILLS_QUERY } from '@load-balancing/graphql/queries/load-balancing-worker-skills';
import { skillsFromWorkerSkills } from './_schedule-worker-skills-service';

export function ScheduleWorkerSkills({
  workerId,
  scheduleGroupId,
  asOf,
}: {
  workerId: string;
  scheduleGroupId: string;
  asOf: string;
}) {
  const { data, loading, error } = useQuery(
    LOAD_BALANCING_WORKER_SKILLS_QUERY,
    {
      variables: { id: workerId, scheduleGroupId, on: asOf },
      skip: !workerId || !scheduleGroupId,
    }
  );

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="ScheduleWorkerSkills"
        messageType="contextual"
      />
    );
  }

  if (loading && !data) return <LoadingState size="sm" />;

  const skills = skillsFromWorkerSkills(data);

  if (skills.length === 0) {
    return <Text secondary>No skills.</Text>;
  }

  return (
    <Gap size="xs" align="center" wrap className="schedule-worker-skills">
      {skills.map((skill) => (
        <Tag
          key={skill.id}
          kind="chip"
          size="lg"
          color="steelLightest"
          textColor="midnightRegular"
        >
          {skill.name}
        </Tag>
      ))}
    </Gap>
  );
}
